<template>
  <RegistrationLayout>
    <p>簡単な手順で、ご利用中の口コミサイトと連携できます。</p>
    <p>まずは、１ブランドを登録・連携してみましょう。</p>
    <div class="initial-registration__brand">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form v-if="!brand_loading && !business_types_loading" @submit.prevent="handleSubmit($event, onSubmit)">
          <div class="registration__body__form">
            <ValidationProvider
              v-slot="{ errors, value, handleChange }"
              v-model="brand.name"
              name="ブランド名"
              rules="required"
            >
              <p class="c-formLabel">
                ブランド名
                <span v-for="error in errors" :key="error" class="c-error-msg">
                  {{ error }}
                </span>
              </p>
              <TextField :value="value" name="brand[name]" placeholder="ブランド名を入力してください" @input="handleChange" />
            </ValidationProvider>
          </div>
          <div class="registration__body__form">
            <ValidationProvider
              v-slot="{ errors, value, handleChange }"
              v-model="brand.business_type_id"
              name="業種"
              rules="required"
            >
              <p class="c-formLabel">
                業種
                <span class="c-error-msg">{{ errors[0] }}</span>
              </p>
              <Select :model-value="value" name="brand[business_type]" :options="businessTypes" @update:model-value="handleChange" />
            </ValidationProvider>
          </div>
          <button class="c-button__item c-registration-button c-button__item--primary c-registration-button" type="submit">
            Google連携をする
          </button>
        </form>
        <Loading v-else />
      </ValidationObserver>
    </div>
  </RegistrationLayout>
</template>

<script>
import RegistrationLayout from '../layouts/RegistrationLayout'
import {mapActions, mapState} from 'vuex'
import TextField from '../components/TextField'
import Select from '../components/Select'
import Loading from '../components/Loading'

export default {
  name: 'RegistrationsBrand',
  components: {
    RegistrationLayout,
    TextField,
    Select,
    Loading
  },
  computed: {
    ...mapState({
      brand: state => state.companiesRegistrationsBrand.brand,
      brand_loading: state => state.companiesRegistrationsBrand.loading,
      business_types: state => state.companiesRegistrationsBusinessTypes.data.data,
      business_types_loading: state => state.companiesRegistrationsBusinessTypes.loading,
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
    businessTypes() {
      const obj = {}
      this.business_types.map(v => {
        const attributes = v.attributes
        obj[attributes.name] = v.id
      })
      return obj
    }
  },
  created() {
    this.readBrand(this.currentCompanyUuid)
    this.readBusinessTypes()
  },
  methods: {
    ...mapActions({
      readBrand: 'companiesRegistrationsBrand/readRegistrationsBrand',
      writeBrand: 'companiesRegistrationsBrand/writeRegistrationsBrand',
      readBusinessTypes: 'companiesRegistrationsBusinessTypes/readRegistrationsBusinessTypes'
    }),
    onSubmit() {
      this.writeBrand(this.currentCompanyUuid)
    }
  },
}
</script>

<style lang="scss" scoped>
.initial-registration__brand {
  margin: 64px auto 0;
  max-width: 512px;
}
.c-registration-button {
  margin-top: 86px;
  margin-right: auto;
  margin-left: auto;
}
.registration__body__form {
  margin-bottom: 32px;
}
.c-error-wrapper {
  margin-left: 5px;
}
</style>
